import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export interface AnalyzerSwitchOperation {
  kind: 'Update' | 'Add' | 'Remove';
  analyzerId: number;
  switchId: number;
  id?: number;
  newSwitchChannel?: number;
  newSwitchOutput?: number;
}

export const executeAnalyzerSwitchOperations = async (operations: AnalyzerSwitchOperation[]) => {
    const endpoint = '/api/analyzers/executeOperations';
    const payload = operations;
  
    try {
      const response = await axios.post(endpoint, payload);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  

export const useExecuteAnalyzerSwitchOperations = () => {
  return useMutation((operations: AnalyzerSwitchOperation[]) => executeAnalyzerSwitchOperations(operations));
};
